import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class KeycloakTokenInterceptor implements HttpInterceptor {
  private readonly resourceUrls = [
    environment.datahubApiUrl,
    environment.datahubApiUrlV2,
    environment.lpDatahubApi,
    environment.baseUrl,
    environment.fundSandboxApiUrl,
  ].filter(Boolean);

  constructor(private readonly authService: AuthService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.shouldAttach(req.url)) {
      return next.handle(req);
    }

    return this.authService.getFreshBearerToken().pipe(
      switchMap(bearerToken =>
        next.handle(this.withToken(req, bearerToken)).pipe(
          catchError((error: unknown) => {
            if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
              return throwError(() => error);
            }

            return this.authService
              .forceRefreshBearerToken()
              .pipe(
                switchMap(freshBearerToken =>
                  next.handle(this.withToken(req, freshBearerToken))
                )
              );
          })
        )
      )
    );
  }

  private shouldAttach(url: string): boolean {
    return this.resourceUrls.some(baseUrl =>
      url.toLowerCase().startsWith(baseUrl.toLowerCase())
    );
  }

  private withToken(
    req: HttpRequest<unknown>,
    bearerToken: string
  ): HttpRequest<unknown> {
    return req.clone({ setHeaders: { Authorization: bearerToken } });
  }
}
